import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import DropdownMenu, { DropdownMenuItem } from "../../DropdownMenu";
import PDFTooltip from "../../Tooltips/pdfToolTip";
import { upgradeToProText } from "../../../constants/ToolTipsText";
import useMegatron from "../../../hooks/useMegatron";

interface PageHeaderMenuProps {
  readonly menuItems: DropdownMenuItem[];
}

function PageHeaderMenu({ menuItems }: PageHeaderMenuProps) {
  const [anchor, setAnchor] = useState<HTMLButtonElement | null>(null);
  const {megatronLiteUser} = useMegatron();
  const pathname = window.location.pathname.split("/");
  const url = pathname.slice(0, -1).join("/");

  return (
    <PDFTooltip title={megatronLiteUser && url == "/private/verify/details" ? upgradeToProText : ""} >
    <div style={{cursor: megatronLiteUser && url == "/private/verify/details" ? "not-allowed" : "pointer"}}>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={(event) => setAnchor(event.currentTarget)}
        disabled={megatronLiteUser && url == "/private/verify/details"}
      >
        <MoreVertIcon />
        Menu
      </Button>
      <DropdownMenu
        target={anchor}
        onClose={() => setAnchor(null)}
        items={menuItems}
      />
    </div>
    </PDFTooltip>
  );
}

export default PageHeaderMenu;
